import { memo } from 'react'
import cn from 'classnames'

import type { DividerProps } from './types'

import styles from './Divider.module.scss'

/** Тонкий разделитель $color-divider внутри карточек/строк. */
export const Divider = memo(function Divider(props: DividerProps) {
  const { orientation = 'HORIZONTAL' } = props

  return <div className={cn(styles.root, styles[`orientation_${orientation}`])} />
})
